import { LineItemSourcingCaseAssignments } from '../../ContractDemandAwardingWidget.hooks';
import { ContractDemand } from '../../ContractDemandAwardingWidget.types';

import { useAwardingDataGridConfig } from './AwardingDataGrid.config';
import { DataGridProStyled } from './AwardingDataGrid.styled';

export interface AwardingDataGridProps {
  contractDemand: ContractDemand;
  loading?: boolean;
  lineItemAssignments: LineItemSourcingCaseAssignments;
}

export const AwardingDataGrid = ({ contractDemand, loading, lineItemAssignments }: AwardingDataGridProps) => {
  const gridProps = useAwardingDataGridConfig({ contractDemand, lineItemAssignments });

  return (
    <DataGridProStyled
      autoHeight
      loading={loading}
      hideFooter
      disableColumnMenu
      getRowHeight={() => 'auto'}
      defaultGroupingExpansionDepth={1}
      getRowClassName={(row) => {
        return row.row.type;
      }}
      {...gridProps}
    />
  );
};
